/* eslint-disable import/no-unused-modules */
import { useCallback } from 'react';

/**
 * Hook for dynamically loading Google Fonts
 * @returns Object containing loadFont function
 */
export const useLoadFont = () => {
    const loadFont = useCallback(
        async (family: string, googleFontName?: string): Promise<boolean> => {
            const fontToLoad = googleFontName || family;

            // Check if font is already loaded using data-font attribute
            const existingLink = document.querySelector(
                `link[data-font="${fontToLoad}"]`,
            );
            if (existingLink) {
                return false;
            }

            // Create link element for Google Fonts
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(fontToLoad)}&display=swap`;
            link.setAttribute('data-font', fontToLoad);

            // Append to document head
            document.head.appendChild(link);

            // Wait for font to actually load
            try {
                // @ts-ignore
                if (document.fonts && document.fonts.load) {
                    // @ts-ignore
                    await document.fonts.load(`italic 48px ${family}`);
                }
            } catch (e) {
                console.error('Font load error:', e);
            }
            return true;
        },
        [],
    );

    return { loadFont };
};
